import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const LazyImage = ({ src, alt, width = '100%', height = 'auto', effect = 'blur', className = '', ...rest }) => {
  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      effect={effect}
      className={className}
      {...rest}
    />
  );
};

export default LazyImage;
